var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.84211H1.33333V0.684211C1.33333 0.502747 1.2631 0.328715 1.13807 0.200401C1.01305 0.0720862 0.843478 0 0.666667 0C0.489856 0 0.320286 0.0720862 0.195262 0.200401C0.0702379 0.328715 0 0.502747 0 0.684211V12.3158C0 12.4973 0.0702379 12.6713 0.195262 12.7996C0.320286 12.9279 0.489856 13 0.666667 13C0.843478 13 1.01305 12.9279 1.13807 12.7996C1.2631 12.6713 1.33333 12.4973 1.33333 12.3158V10.9474H14.6667V12.3158C14.6667 12.4973 14.7369 12.6713 14.8619 12.7996C14.987 12.9279 15.1565 13 15.3333 13C15.5101 13 15.6797 12.9279 15.8047 12.7996C15.9298 12.6713 16 12.4973 16 12.3158V6.84211Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 5.47368C4.2711 5.47368 3.88442 5.3533 3.55553 5.12775C3.22663 4.90221 2.97028 4.58163 2.81891 4.20656C2.66753 3.83149 2.62793 3.41878 2.7051 3.0206C2.78227 2.62243 2.97275 2.25669 3.25245 1.96962C3.53216 1.68256 3.88852 1.48706 4.27649 1.40786C4.66445 1.32866 5.06658 1.36931 5.43203 1.52467C5.79749 1.68003 6.10984 1.94312 6.32961 2.28067C6.54937 2.61823 6.66667 3.01508 6.66667 3.42105C6.66667 3.96545 6.45595 4.48754 6.08088 4.87248C5.70581 5.25743 5.1971 5.47368 4.66667 5.47368Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.47368H8.66667C8.48986 5.47368 8.32029 5.4016 8.19526 5.27328C8.07024 5.14497 8 4.97094 8 4.78947V2.73684C8 2.55538 8.07024 2.38135 8.19526 2.25303C8.32029 2.12472 8.48986 2.05263 8.66667 2.05263H14C14.5304 2.05263 15.0391 2.26889 15.4142 2.65383C15.7893 3.03878 16 3.56087 16 4.10526V5.47368Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.c35ca625.svg";
export { ForwardRef as ReactComponent };